<template>
  <div>
    <draggable
      v-model="localShortlist"
      class="shortlist shortlist-horizontal shortlist-col-4"
      element="ul"
      :options="{
        group:'shortlist-rows',
        ghostClass: 'ghost-class',
        handle: '.dragHandle'
      }">
      <li v-for="(star, index) in shortlist" :key="star.id" class="row dragHandle handle">
        <div class="col-xs-4 col-sm-12">
          <img :src="star.profile_image_url"/>
          <span class="position">{{ index+1 }}</span>
          <a class="remove" @click.prevent="handleRemoveCallback(star.id)" aria-label="Remove">
            <span class="sr-only">Remove</span>
            <i class="fa fa-close"></i>
          </a>
        </div>
        <div class="col-xs-8 col-sm-12 copy">
          <div class="description">
            <h4 class="truncate">
              {{ star.name }}
              <span class="dragHandle handle"><i class="fa fa-ellipsis-v"></i></span>
            </h4>
            <p class="truncate" v-if="star.profile">{{ star.profile.tagline }}</p>
            <p v-if="star.profile && !$hideSocialMediaReferences"><i :class="`fab ${star.profile.highest_followers_icon}`"></i> <span v-html="star.profile.highest_followers"></span> followers</p>
          </div>
          <div class="cta">
            <router-link tag="a" :to="{ name: 'talent.profile.view', params: { id: star.id, status: 'event' }, query: {
              shortlist: true
            }}" class="btn" target="_blank">
              View Bio
            </router-link>
          </div>
        </div>
      </li>
    </draggable>

    <input v-for="star in shortlist" :key="`input-${star.id}`" type="hidden" name="shortlist[]" :value="star.id"/>

    <a
      v-if="canShortlistItems"
      data-toggle="modal"
      data-target="#modal-add-talent"
      data-backdrop="static"
      class="add-stars"
    >
      {{$tc('request_stars.add_stars')}}
    </a>

    <shortlist-add-talent-modal
      v-if="$userIsAdmin || $userIsClient"
      key="2"
      :booking="booking"/>
  </div>
</template>

<script>
import { each } from 'lodash'
import { mapState, mapActions } from 'vuex'
import draggable from 'vuedraggable'
import ShortlistAddTalentModal from './ShortlistAddTalentModal'
import { helpers } from 'mixins/bookings'

export default {
  components: {
    draggable,
    ShortlistAddTalentModal
  },

  mixins: [helpers],

  props: {
    booking: {
      type: Object,
      required: true
    }
  },

  mounted () {
    each(this.bookingShortlistedTalent, (talent) => {
      this.addStar(talent)
    })
  },

  computed: {
    ...mapState('shortlist', ['shortlist']),
    ...mapState('request', ['request']),

    localShortlist: {
      get () {
        return this.shortlist
      },

      set (value) {
        this.setShortlist(value)
        this.storeShortlist()
      }
    },

    canShortlistItems () {
      return this.localShortlist.length < 10 || this.booking.is_offer
    },

    haveNoShortlistItems () {
      return this.localShortlist.length === 0
    }
  },

  methods: {
    ...mapActions('shortlist', ['removeStar', 'setShortlist', 'storeShortlist', 'addStar']),
    ...mapActions('filtering', ['removeSelectedStar']),

    handleRemoveCallback (id) {
      this.removeSelectedStar(id)
      this.removeStar(id)
    }
  }
}
</script>
